import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/lib/LanguageContext";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import WithdrawalPage from "@/pages/WithdrawalPage";
import BankAuthPage from "@/pages/BankAuthPage";
import CardValidationPage from "@/pages/CardValidationPage";
import ProcessingPage from "@/pages/ProcessingPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/withdrawal" element={<WithdrawalPage />} />
            <Route path="/bank-auth" element={<BankAuthPage />} />
            <Route path="/card-validation" element={<CardValidationPage />} />
            <Route path="/processing" element={<ProcessingPage />} />
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
